"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ScrollInViewBehaviourType;
(function (ScrollInViewBehaviourType) {
    ScrollInViewBehaviourType["AUTO"] = "auto";
    ScrollInViewBehaviourType["SMOOTH"] = "smooth";
})(ScrollInViewBehaviourType = exports.ScrollInViewBehaviourType || (exports.ScrollInViewBehaviourType = {}));
var ScrollInViewBlockType;
(function (ScrollInViewBlockType) {
    ScrollInViewBlockType["CENTER"] = "center";
    ScrollInViewBlockType["START"] = "start";
})(ScrollInViewBlockType = exports.ScrollInViewBlockType || (exports.ScrollInViewBlockType = {}));
